import { Pipe, PipeTransform } from '@angular/core';
import { PrintCardContentViewModel } from '../../print-cards/components/cards/card-content/shared/print-card-content-view-model';
import { PrintCardColumnViewModel } from '../../display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/print-card-column-view-model';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'getExpandedGridSizeMode',
  standalone: false
})
export class GetExpandedGridSizeModePipe implements PipeTransform {
  transform(
    viewModel: PrintCardContentViewModel,
    spoofedGridColVMs: PrintCardColumnViewModel[],
    spacesBetweenX: boolean = false,
    removeSpacing: boolean = true,
    upperCaseUnits: boolean = true
  ): Observable<string | null> {
    const expandedGridSize$ = viewModel
      ?.getExpandedGridSizeMode$(spoofedGridColVMs, removeSpacing, upperCaseUnits)
      ?.pipe(map(size => (spacesBetweenX ? size?.replace('x', ' x ') : size)));
    return expandedGridSize$ || of(null);
  }
}
